import BaseAPI from "@/api/BaseAPI";

export class AppealsAPI extends BaseAPI{
    constructor() {
        super('/form5/appeal');
    }
    /**
     * @param {Number} orgId orgId
     * */
    read(orgId) {
        return this.http.get(`/getAll`, {data:{orgId}})
    }
    /**
     * @param {string} id appealID
     * */
    getById(id,) {
        return this.http.get(`/get`, {data:{id}})
    }
    /**
     * @param {
     *    {
     *   "id"?: string,
     *   "userUuid": string,
     *   "userType": string,
     *   "userId": number,
     *   "form5Id": number,
     *   "formAId": number,
     *   "form5KeyId": string,
     *   "kcpGroup": {
     *     "id": number
     *   },
     *   "jsonId": string,
     *   "oldValue": string,
     *   "newValue": string,
     *   "appeal": string,
     *   "fileId": string,
     *   "date"?: Date,
     *   "decision": string,
     *   "accept"?: boolean,
     *   "dateReason"?: Date,
     *   }
     * } data
     * */
    setAppeal(data) {
        return this.http.put('/set', {data})
    }
    /**
    *@description appeal for forms 5.15 5.18 5.19 5.20
     * @param {{
     *     "jsonId": string,
     *   "rowId": number,
     *   "newValue": string,
     *   "kcpGroupId": number,
     *   "orgId": number
     * }} data
    * */
    setAppealByKey(data){
        return this.http.post('/byKey/set', {data})
    }
    closeAppeal(data){
        return this.http.put('/admin/close',{data})
    }
}
export default new AppealsAPI()